import React from "react";
import cl from "./ExprStatus.module.scss";
import { inQueueIcons, statusIcons } from "../../../../constants/statusConst";
import SwitchBtn from "../../../UI/SwitchBtn/SwitchBtn";
import DropDownList from "../../../UI/DropDownList/DropDownList";

const ExprStatusAtr = ({
  stat = "new",
  inQueue,
  short,
  onStatusChange,
  onToggleQueue,
  className,
}) => {
  const current = statusIcons[stat];
  const allowedNext = current?.possible || [];
  return (
    <div
      className={[
        short ? cl["status-wrap-short"] : cl["status-wrap"],
        className || "",
      ].join(" ")}>
      {/* inQueue toggle */}
      <div className={cl["queue-box"]}>
        {short && (
          <div title={inQueue ? "Remove from the queue" : "Add to the queue"}>
            {inQueueIcons[+inQueue]}
          </div>
        )}
        {!short && (
          <>
            <p>{"Adding to the queue"}</p>
            <div
              className={cl["queue-ico"]}
              // onClick={() => onToggleQueue && onToggleQueue(!inQueue)}
              title={inQueue ? "Remove from the queue  " : "Add to the queue"}>
              {inQueue ? "In the queue" : "Not in the queue"}
              <SwitchBtn
                value={inQueue}
                setValue={onToggleQueue}
                disabled={!!current?.queueDisable}
              />
            </div>
          </>
        )}
      </div>
      {/* Status block */}
      <div className={cl["status-box"]}>
        {short && <div title={current?.title}>{current?.icon}</div>}

        {!short && (
          <>
            <p>Status </p>
            <DropDownList
              val={stat}
              onValueChange={onStatusChange}
              list={allowedNext}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ExprStatusAtr;
